import React from 'react';
import { Route } from 'react-router-dom';
// import ErrorPage from '../ErrorPage/ErrorPage';
import { Redirect } from 'react-router-dom'

const ProtectedRoute = (props) => {
 const ChildComponent = props.component;
 if (props.isAuthenticated) {
   return(
      <Route exact path={props.path}
             render={ () =>
      <ChildComponent {...props}/>
      } />
   );
 }
 return (
    <Redirect to="/"/>
 );
};

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/Components/ProtectedRoute/ProtectedRoute.jsx